import { minLength, required } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { RequestMVRFormFields } from './types';

const useController = () => {
  const { handleSubmit } = useFormContext<RequestMVRFormFields>();
  const { runRequest } = useRunRequest();

  const requestMVR = async (data: RequestMVRFormFields) => {
    await runRequest({
      fetchType: 'CREATE',
      resource: TurnResourcesEnum.CompassOrderReports,
      params: {
        id: data.compass_order_report_id,
        target: TurnTargetsEnum.ControlNumbers,
        data,
      },
      mode: 'notify',
      notify: {
        onSuccess: { message: 'MVR Script Requested Successfully' },
        onError: { message: 'Error: There was an error during MVR Script execution' },
      },
    });
  };

  const textInputCommonProps = (digits: number) => ({
    inputProps: { maxLength: digits },
    parse: (value: string) => (value ? value.replace(/\D/g, '').slice(0, digits) : value),
    validate: [required(), minLength(digits)],
  });

  return {
    requestMVR: handleSubmit(requestMVR),
    textInputCommonProps,
  };
};

export default useController;
